/// <amd-module name="Artifacts/Pypi/components/PyPiPackagePeople" />
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { PackagePerson } from "Artifacts/Package/components/package-details-common/PackagePerson";
import * as PackageRes from "Artifacts/Package/Resources";
import * as PypiRes from "Artifacts/Pypi/Resources";
import { IPerson } from "Artifacts/Root/types/IPerson";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IPyPiPackagePeopleProps {
  pageContext: IVssPageContext;
  author: string;
  authorEmail: string;
  maintainer: string;
  maintainerEmail: string;
}

export class PyPiPackagePeople extends React.PureComponent<IPyPiPackagePeopleProps> {
  public render(): JSX.Element | null {
    if (!this.props.author && !this.props.maintainer) {
      return null;
    }

    return (
      <div className="pypi-package-people">
        <PackageAttribute title={PackageRes.PackagePeople_Title}>
          {this.props.author && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {PackageRes.PackagePeople_Author}
              </div>
              <PackagePerson
                pageContext={this.props.pageContext}
                key={this.props.author}
                person={this.ToPerson(this.props.author, this.props.authorEmail)}
              />
            </div>
          )}
          {this.props.maintainer && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {PypiRes.PyPiPackagePeople_Maintainer}
              </div>
              <PackagePerson
                pageContext={this.props.pageContext}
                key={this.props.maintainer}
                person={this.ToPerson(this.props.maintainer, this.props.maintainerEmail)}
              />
            </div>
          )}
        </PackageAttribute>
      </div>
    );
  }

  private ToPerson(name: string, email: string): IPerson {
    return {
      name: name,
      email: email,
      url: "",
    } as IPerson;
  }
}
